import classnames from 'classnames'
import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { Form, Icon, Message } from 'semantic-ui-react'

import { EntityCard } from 'sports'
import { ImageCrop, SimpleButton } from 'ui'

import OptionSchema from '../../schemas/OptionSchema'

import styles from './index.css'

const isRequired = (val) => (val.replaceAll(/([^a-z0-9]+)/gi, '').length > 0 ? null : 'Requerido')

const is3Chars = (val) =>
  val.trim().replaceAll(/([^a-z0-9]+)/gi, '').length >= 3 ? null : 'Incluye 3 o más caracteres'

const isNickname = (val) => {
  if (val.trim().match(/([^a-z 0-9]+)/gi)) {
    return 'El nickname debe tener letras y números'
  }
  if (val.trim().length < 3 || val.trim().length > 10) {
    return 'El nickname debe tener de 3 a 10 caracteres'
  }
  return null
}

class CreateForm extends PureComponent {
  addSelectedImage = () =>
    this.setState((prevState) => ({
      croppingImages: (prevState.croppingImages + 1) % 3,
    }))

  el = createRef()

  state = {
    croppingImages: 0,
    fields: {
      institution: {
        error: null,
        getError: (val) => this.shouldRenderInstitutionSelector() && isRequired(val),
        value: '',
      },
      institution_image: {
        error: null,
        getError: Function.prototype,
        value: null,
      },
      institution_name: {
        error: null,
        getError: (val) => this.shouldRenderInstitutionCreator() && is3Chars(val),
        value: '',
      },
      institution_nickname: {
        error: null,
        getError: (val) => this.shouldRenderInstitutionCreator() && isNickname(val),
        value: '',
      },
      institution_type: {
        error: null,
        getError: (val) => this.shouldRenderInstitutionCreator() && isRequired(val),
        value: '',
      },
      tournament_category: {
        error: null,
        getError: isRequired,
        value: '',
      },
      tournament_city: {
        error: null,
        getError: isRequired,
        value: '',
      },
      tournament_discipline: {
        error: null,
        getError: isRequired,
        value: '',
      },
      tournament_gender: {
        error: null,
        getError: isRequired,
        value: '',
      },
      tournament_image: {
        error: null,
        getError: Function.prototype,
        value: null,
      },
      tournament_level: {
        error: null,
        getError: isRequired,
        value: '',
      },
      tournament_name: {
        error: null,
        getError: is3Chars,
        value: '',
      },
      tournament_nickname: {
        error: null,
        getError: isNickname,
        value: '',
      },
      tournament_season: {
        error: null,
        getError: is3Chars,
        value: `${new Date().getFullYear()}`,
      },
    },
  }

  onChangeInput = ({ target: { name, value } }) =>
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        [name]: {
          ...fields[name],
          error: null,
          value,
        },
      },
    }))

  onChangeSelect = (_event, target) => this.onChangeInput({ target })

  onSaveForm = () => {
    const fields = { ...this.state.fields }
    let errors = 0

    Object.keys(fields).forEach((field) => {
      fields[field].error = fields[field].getError(fields[field].value)
      errors += !!fields[field].error
    })

    if (errors) {
      this.setState({ fields }, () => this.el?.current?.querySelector('.field.error input')?.focus())
    } else {
      const data = {}
      Object.keys(fields).forEach((key) => {
        data[key] = fields[key].value
      })
      this.props.onSave(data)
    }
  }

  removeSelectedImage = () =>
    this.setState((prevState) => ({
      croppingImages: Math.max(prevState.croppingImages - 1, 0),
    }))

  shouldRenderInstitutionCreator = () => !this.shouldRenderInstitutionSelector()

  shouldRenderInstitutionSelector = () => this.props.institutions.length > 0

  renderInstitutionCreator() {
    const { institutionTypes } = this.props
    const { fields } = this.state

    return (
      <div>
        <h2>1. Crea una institución para tu torneo</h2>
        <p>Una institución te permitirá agrupar tus torneos y encontrarlos en el mismo lugar.</p>
        <Form autoComplete="off">
          <div className={styles.formColumns}>
            <div className={styles.avatarColumn}>
              <ImageCrop
                className={styles.avatarCrop}
                cropHeight={200}
                cropWidth={200}
                onCut={(_, value) => {
                  this.onChangeInput({ target: { name: 'institution_image', value } })
                  this.removeSelectedImage()
                }}
                onDeselect={this.removeSelectedImage}
                onRemove={() => this.onChangeInput({ target: { name: 'institution_image', value: null } })}
                onSelect={this.addSelectedImage}
              >
                <div>
                  <Icon name="building" size="big" />
                  <br />
                  Agrega una imagen o
                  <br />
                  avatar para tu institución
                </div>
              </ImageCrop>
            </div>
            <div>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.institution_name.error}
                  label="Nombre"
                  name="institution_name"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.institution_name.value}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.institution_nickname.error}
                  label="Nickname"
                  maxLength={10}
                  name="institution_nickname"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.institution_nickname.value}
                />
              </Form.Group>
            </div>
          </div>
          <Form.Group widths="equal">
            <Form.Select
              error={fields.institution_type.error}
              label="Tipo"
              name="institution_type"
              onChange={this.onChangeSelect}
              options={institutionTypes}
              required
              size="mini"
              value={fields.institution_type.value}
            />
            <Form.Field>
              <p>
                <b>* Nickname: </b> Es un nombre corto que se usará cuando el nombre sea muy largo.
              </p>
              <p>
                Toda la información es requerida, te ayuda y a otros a encontrar torneos he información más relevante.
              </p>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    )
  }

  renderInstitutionSelector() {
    const { fields } = this.state
    const { institutions } = this.props

    const institution = institutions.find((i) => i.value === fields.institution.value)

    return (
      <div>
        <h2>1. Selecciona una institución para tu torneo</h2>
        <p>Esta institución te permitirá agrupar tus torneos y encontrarlos en el mismo lugar.</p>
        <Form autoComplete="off">
          <Form.Group>
            <Form.Select
              error={fields.institution.error}
              label="Institución"
              name="institution"
              onChange={this.onChangeSelect}
              options={institutions}
              required
              size="mini"
              value={fields.institution.value}
              width={8}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              {!!institution && (
                <EntityCard
                  key={institution.id}
                  fallbackIconName="building outline"
                  image={institution.avatar}
                  title={institution.name}
                >
                  {institution.type.name}, {institution.city.name}
                </EntityCard>
              )}
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <p>
                <b>* Nickname: </b>
                Es un nombre corto que se usará cuando el nombre sea muy largo.
              </p>
              <p>
                Toda la información es requerida, te ayuda y a otros a encontrar torneos he información más relevante.
              </p>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    )
  }

  renderTournamentCreator() {
    const { fields } = this.state
    const { categories, cities, disciplines, genders, levels } = this.props

    return (
      <div>
        <h2>2. Crea tu torneo</h2>
        <p>Configura los datos básicos de tu competición.</p>
        <Form autoComplete="off">
          <div className={styles.formColumns}>
            <div className={styles.avatarColumn}>
              <ImageCrop
                className={styles.avatarCrop}
                cropHeight={200}
                cropWidth={200}
                onCut={(_, value) => {
                  this.onChangeInput({ target: { name: 'tournament_image', value } })
                  this.removeSelectedImage()
                }}
                onDeselect={this.removeSelectedImage}
                onRemove={() => this.onChangeInput({ target: { name: 'tournament_image', value: null } })}
                onSelect={this.addSelectedImage}
              >
                <div>
                  <Icon name="trophy" size="big" />
                  <br />
                  Agrega una imagen o
                  <br />
                  avatar para tu torneo
                </div>
              </ImageCrop>
            </div>
            <div>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.tournament_name.error}
                  label="Nombre"
                  name="tournament_name"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.tournament_name.value}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.tournament_nickname.error}
                  label="Nickname"
                  maxLength={10}
                  name="tournament_nickname"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.tournament_nickname.value}
                />
              </Form.Group>
            </div>
          </div>
          <Form.Group widths="equal">
            <Form.Select
              error={fields.tournament_city.error}
              label="Ciudad"
              name="tournament_city"
              onChange={this.onChangeSelect}
              options={cities}
              required
              search
              size="mini"
              value={fields.tournament_city.value}
            />
            <Form.Select
              error={fields.tournament_discipline.error}
              label="Disciplina"
              name="tournament_discipline"
              onChange={this.onChangeSelect}
              options={disciplines}
              required
              size="mini"
              value={fields.tournament_discipline.value}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              error={fields.tournament_category.error}
              label="Categoría"
              name="tournament_category"
              onChange={this.onChangeSelect}
              options={categories}
              required
              size="mini"
              value={fields.tournament_category.value}
            />
            <Form.Select
              error={fields.tournament_level.error}
              label="Nivel"
              name="tournament_level"
              onChange={this.onChangeSelect}
              options={levels}
              required
              size="mini"
              value={fields.tournament_level.value}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              error={fields.tournament_gender.error}
              label="Género"
              name="tournament_gender"
              onChange={this.onChangeSelect}
              options={genders}
              required
              size="mini"
              value={fields.tournament_gender.value}
            />
            <Form.Input
              error={fields.tournament_season.error}
              label="Temporada"
              maxLength={15}
              name="tournament_season"
              onChange={this.onChangeInput}
              required
              size="mini"
              value={fields.tournament_season.value}
            />
          </Form.Group>
        </Form>
      </div>
    )
  }

  render() {
    const { className, onCancel, saving } = this.props
    const { croppingImages } = this.state

    return (
      <div className={classnames(styles.container, className)}>
        <div className={styles.containerColumns} ref={this.el}>
          {this.shouldRenderInstitutionSelector() && this.renderInstitutionSelector()}
          {this.shouldRenderInstitutionCreator() && this.renderInstitutionCreator()}
          {this.renderTournamentCreator()}
        </div>
        <div className={styles.actionBar}>
          {croppingImages ? (
            <Message>
              <Icon name="info" />
              Termina de modificar la imagen actual para continuar.
            </Message>
          ) : (
            <>
              {!saving && <SimpleButton onClick={onCancel} secondary value="Cancelar" />}
              <SimpleButton
                disabled={saving}
                onClick={this.onSaveForm}
                value={saving ? 'Creando Torneo...' : 'Crear Torneo'}
              />
            </>
          )}
        </div>
      </div>
    )
  }
}

CreateForm.propTypes = {
  categories: PropTypes.arrayOf(OptionSchema).isRequired,
  cities: PropTypes.arrayOf(OptionSchema).isRequired,
  disciplines: PropTypes.arrayOf(OptionSchema).isRequired,
  genders: PropTypes.arrayOf(OptionSchema).isRequired,
  institutions: PropTypes.arrayOf(OptionSchema).isRequired,
  institutionTypes: PropTypes.arrayOf(OptionSchema).isRequired,
  levels: PropTypes.arrayOf(OptionSchema).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,

  className: PropTypes.string,
  saving: PropTypes.bool,
}

CreateForm.defaultProps = {
  className: '',
  saving: false,
}

export default CreateForm
